import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useGoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import { Button } from "reactstrap";
const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const GoogleAuthChat = ({ setJoin_now }) => {
  const dispatch = useDispatch();
  const googleAuth_success = (res) => {
    const social_user = {
      first_name: res.profileObj.givenName,
      last_name: res.profileObj.familyName,
      email: res.profileObj.email,
      avatar: res.profileObj.imageUrl,
    };
    dispatch({ type: "GET_SOCIAL_USER", payload: social_user });
    setJoin_now(true);
  };
  const googleAuth_error = (err) => {
    setJoin_now(false);
  };
  const { signIn } = useGoogleLogin({
    onSuccess: (codeResponse) => googleAuth_success(codeResponse),
    onFailure: (codeResponse) => googleAuth_error(codeResponse),
    clientId: REACT_APP_GOOGLE_CLIENT_ID,
  });
  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: REACT_APP_GOOGLE_CLIENT_ID,
        scope: "email",
      });
    }

    gapi.load("client:auth2", start);
  }, []);

  return (
    <GoogleOAuthProvider>
      <Button onClick={() => signIn()}>Join now</Button>
    </GoogleOAuthProvider>
  );
};

export default GoogleAuthChat;
